import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { PushNotificationService } from '@core/services/notifications/push-notification.service';
import { AskDropdownDirective } from 'asksuite-citrus';
import {
  NotificationRegisterError,
  UserNotificationStateService,
} from 'src/app/core/services/notifications/user-notification-state.service';
import { environment } from 'src/environments/environment';

type NotificationIcon =
  | 'notifications'
  | 'notifications_off'
  | 'notification_important';

@Component({
  selector: 'app-notification-toggle',
  templateUrl: './notification-toggle.component.html',
  styleUrls: ['./notification-toggle.component.scss'],
})
export class NotificationToggleComponent implements OnInit {
  @ViewChildren(AskDropdownDirective) dropdowns!: QueryList<AskDropdownDirective>;
  protected notificationPermission!: boolean;
  protected userDeviceStatus: boolean | null = null;
  protected isLoadingUserDevice!: boolean;
  protected notificationRegisterError!: NotificationRegisterError | null;
  protected notificationIcon: NotificationIcon = 'notifications';
  protected isIOS = false;
  protected isStandalone = false;


  get isSomeDropdownOpen(): boolean {
    return this.dropdowns?.some((dropdown) => dropdown.isRendered) || false;
  }

  constructor(
    private userNotificationStateService: UserNotificationStateService,
    private location: Location,
    private pushNotificationService: PushNotificationService,
  ) { }

  ngOnInit(): void {
    this.resolveDevice();
    this.setupSubscribers();
  }

  loadNotificationPermission(permission: NotificationPermission | null) {
    if (permission === 'granted') {
      this.notificationPermission = true;
      this.isLoadingUserDevice = this.isLoadingUserDevice || this.userDeviceStatus === null;
    } else {
      this.notificationPermission = false;
      this.userDeviceStatus = null;
    }
    this.resolveNotificationIcon();
  }

  loadUserDeviceStatus(status: boolean | null) {
    if (status !== null) {
      this.userDeviceStatus = status;
      this.resolveNotificationIcon();
    }
  }

  enableNotifications() {
    this.userNotificationStateService.setUserDeviceStatus(true);
  }

  disableNotifications() {
    this.userNotificationStateService.setUserDeviceStatus(false);
  }

  configureNotifications() {
    window.open(`${environment.externalUrls.platform}/user-settings/notifications`, '_blank');
  }

  reloadPage() {
    this.location.reload();
  }

  requestPermission() {
    this.pushNotificationService.start();
  }

  private resolveDevice() {
    this.isIOS = this.userNotificationStateService.isIOS;
    this.isStandalone = this.userNotificationStateService.isStandalone;
  }

  private setupSubscribers() {
    this.userNotificationStateService.notificationPermission$.subscribe(
      (permission) => this.loadNotificationPermission(permission)
    );
    this.userNotificationStateService.userDeviceCurrentStatus$.subscribe(
      (status) => this.loadUserDeviceStatus(status)
    );
    this.userNotificationStateService.isLoadingUserDevice$.subscribe(
      (isLoading) => (this.isLoadingUserDevice = isLoading)
    );
    this.userNotificationStateService.notificationRegisterError$.subscribe(
      (error) => {
        this.notificationRegisterError = error;
        this.resolveNotificationIcon();
      }
    );
  }

  private resolveNotificationIcon() {
    if (
      typeof this.notificationPermission === 'boolean' &&
      !this.notificationPermission &&
      !this.notificationRegisterError
    ) {
      return this.setNotificationIcon('notifications_off');
    }

    if (this.notificationRegisterError) {
      return this.setNotificationIcon('notification_important');
    }

    if (typeof this.userDeviceStatus === 'boolean') {
      return this.setNotificationIcon(
        this.userDeviceStatus ? 'notifications' : 'notifications_off'
      );
    }
  }

  private setNotificationIcon(icon: NotificationIcon) {
    this.notificationIcon = icon;
  }
}
